import { startTransition } from 'react';
import { connect } from 'react-redux';

import { RootState } from 'reducers';

import { makeGetFetchedState, makeGetLoadingState } from 'selectors/global';

import { fetchTasks } from 'actions/tasks';

import TaskGroupsFetcher from 'components/TaskGroupsFetcher';

interface SubtasksFetcherProps {
    taskId: string,
    fetched: boolean,
    loading: boolean
}

const SubtasksFetcher = ({ taskId, fetched, loading }: SubtasksFetcherProps) => {
    startTransition(() => {
        if (taskId ) {
            if (!fetched && !loading) {
                fetchTasks({ taskId });
            }
        }
    });

    return null;
}

const makeMapStateToProps = () => {
    const getFetched = makeGetFetchedState();
    const getLoading = makeGetLoadingState();

    return ({ tasks }: RootState, ownProps: { taskId: string }) => {
        return {
            fetched: getFetched(tasks.fetchInfo, 'task', ownProps.taskId),
            loading: getLoading(tasks.fetchInfo, 'task', ownProps.taskId)
        }
    };
}

export default connect(makeMapStateToProps)(SubtasksFetcher);
